<template>
    <div :style="backUrl ? { backgroundImage: `url(${backUrl})` , backgroundSize: 'cover', backgroundRepeat: 'no-repeat' } : {}" class="single-rich-text-display">
        <!-- 顶部标题展示（与页签组件风格统一） -->
        <div class="top-margin"></div>
        <div v-if="title" class="component-title">{{ title }}</div>

        <!-- 富文本内容展示区域 -->
        <div
            style="margin-top: 70px"
            class="rich-text-content"
            v-html="parsedContent"
            :style="{ margin: centerContent ? '0 auto' : '0' }"
        ></div>
        <div class="top-margin"></div>
    </div>
</template>

<script>
export default {
    name: 'SingleRichTextDisplay',
    props: {
        // 富文本源数据（直接传入富文本字符串）
        sourceData: {
            type: String,
            required: true,
            default: ''
        },
        // 组件顶部标题（与页签组件保持一致）
        title: {
            type: String,
            default: ''
        },
        // 可选：内容区域最大宽度
        maxWidth: {
            type: [String, Number],
            default: '1200px'
        },
        // 可选：是否居中显示内容
        centerContent: {
            type: Boolean,
            default: true
        },
        backUrl:{
            type: String,
            default: ''
        },
        detailUrl:{
            type: String,
            default: ''
        },
    },
    data() {
        return {
            parsedContent: '' // 解析后的富文本内容
        }
    },
    watch: {
        sourceData: {
            immediate: true,
            handler(newSource) {
                this.parseRichText(newSource)
            }
        }
    },
    methods: {
        /**
         * 解析富文本数据
         */
        parseRichText(source) {
            try {
                if (!source || source.trim() === '') {
                    // 空数据处理，与页签组件空内容样式逻辑统一
                    this.parsedContent = '<div class="empty-content"><p>暂无富文本内容</p></div>'
                    return
                }
                this.parsedContent = source
            } catch (error) {
                console.error('富文本解析失败:', error)
                // 错误内容样式与页签组件统一
                this.parsedContent = '<div class="error-content"><p>富文本数据解析错误</p></div>'
            }
        }
    }
}
</script>

<style scoped>
/* 基础容器样式 - 与页签组件风格统一 */
.single-rich-text-display {
    width: 100%;
    border: none;
    border-radius: 0;
    background-color: #fff;
}

/* 顶部标题样式 - 与页签组件严格一致 */
.component-title {
    padding: 16px 20px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
}

/* 富文本内容容器 - 与页签组件内边距、行高保持一致 */
.rich-text-content {
    padding: 20px;
    line-height: 1.6;
    color: #333;
    box-sizing: border-box;
    max-width: v-bind(maxWidth);
}

/* 富文本内部元素样式适配 - 与页签组件段落间距等统一 */
.rich-text-content p {
    margin: 0 0 16px 0;
}

.rich-text-content p:last-child {
    margin-bottom: 0;
}

.rich-text-content h1,
.rich-text-content h2,
.rich-text-content h3 {
    margin: 24px 0 16px 0;
    color: #222;
    font-weight: 500;
}

.rich-text-content img {
    max-width: 100%;
    height: auto;
    margin: 16px 0;
    border-radius: 4px;
}

.rich-text-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
}

.rich-text-content table td,
.rich-text-content table th {
    padding: 8px 12px;
    border: 1px solid #e8e8e8;
    text-align: left;
}

.rich-text-content table th {
    background-color: #fafafa;
    font-weight: 500;
}

.rich-text-content ul,
.rich-text-content ol {
    margin: 16px 0;
    padding-left: 24px;
}

.rich-text-content li {
    margin-bottom: 8px;
}

/* 空内容和错误内容样式 - 与页签组件统一 */
.empty-content, .error-content {
    text-align: center;
    padding: 40px 20px;
    color: #999;
    background-color: #fafafa;
    border-radius: 4px;
}

.error-content {
    color: #f56c6c;
    background-color: #fef0f0;
}

/* 响应式适配 - 与页签组件保持一致（若有需要可补充） */
@media (max-width: 768px) {
    .rich-text-content {
        padding: 16px;
    }

    .component-title {
        padding: 12px 16px;
        font-size: 24px;
    }
    .top-margin {
        height: 5vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    }
}
.top-margin {
    height: 5vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    clear: both;
}
</style>